export default __webpack_public_path__ + "static/media/pod.f1bef1bf.svg";